import actions from './actions'

const initialState = {
  registrationsByPlace: [],
  loadingRegistrationsByPlace: false,
  registrationsBySport: [],
  loadingRegistrationsBySport: false,
  membersByPlace: [],
  loadingMembersByPlace: false,
  membersBySport: [],
  loadingMembersBySport: false,
  dashboard: [],
  loadingDashboard: false,
  basicMembersBySport: [],
  loadingBasicMembersBySport: false,
  basicMembersWithoutConsentByPlace: [],
  loadingBasicMembersWithoutConsentByPlace: false,
  basicRegistrationsByPlace: [],
  loadingBasicRegistrationsByPlace: false,
  sportsByPlace: [],
  loadingSportsByPlace: false
};

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload };
    default:
      return state
  }
}
